module.exports = __webpack_public_path__ + "static/media/map-signs.b1b3a3d4.svg";